module.exports = __webpack_public_path__ + "static/media/english.cc7bbbbe.svg";